export default "__VITE_ASSET__BrQhMMEa__"